import ajax from "../../lib/appfuse-react/core/ajax";

const newLecturerService = {

    validate: async (data) => {
        const response = await ajax.post('lecturers/validate', data);
        return response.data;
    },

    complete: async (data) => {
        const response = await ajax.post('lecturers', data)
        return response.data;
    },

}

export default newLecturerService;